import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Messages } from 'src/app/utilities/message';
import { Config } from 'src/environments/config';
import { PaymentService } from '../../payment.service';
import * as CryptoJS from 'crypto-js';
import { OrdersService } from 'src/app/orders/orders.service';
import { shareLink } from 'src/app/utilities/common-file';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-requested-payment',
  templateUrl: './view-requested-payment.component.html',
 })
export class ViewRequestedPaymentComponent implements OnInit {
    isEmail=false;
  isSMS=false;
  url:any;
  qrValue:any;
  QRJSON:any;
  shareLink=shareLink;
  countriesList:any;
  isShowQRCode=false;
  paymentDetails:any;
  encryPaymentId:string;
  payOutModal: NzModalRef;
  sendLinkLoader=false;
  generatedLinkUrl=Config;
  GeneratedLinkForm: UntypedFormGroup;
  currency:any;
  amount :any;
  constructor(public activatedRoute: ActivatedRoute,public ordersService: OrdersService,public notification: NzNotificationService,public message: NzMessageService,public fb:UntypedFormBuilder,public paymentService:PaymentService,public router: Router,public modal: NzModalService) {
    this.GeneratedLinkForm = this.fb.group({
      generatedLink:['',Validators.required],
      data: ['',Validators.required],
      countryCode:[null]
   });
  }

  ngOnInit() {
     this.activatedRoute.params.forEach((urlParams) => {
     let descrypt = CryptoJS.AES.decrypt(urlParams.paymentDetails,'paymentDetails');
     this.paymentDetails=JSON.parse(descrypt.toString(CryptoJS.enc.Utf8));
     this.encryPaymentId =encodeURIComponent(CryptoJS.AES.encrypt(this.paymentDetails.paymentId,'paymentId').toString());
     this.url=this.generatedLinkUrl.merchantPaymentLink+this.encryPaymentId;
     this.GeneratedLinkForm.controls.generatedLink.setValue(this.url);
   });
   this.getCountries();
  }
  chckBoxChange(){
   this.GeneratedLinkForm.reset();
    this.url=this.generatedLinkUrl.merchantPaymentLink+this.encryPaymentId;
   this.GeneratedLinkForm.controls.generatedLink.setValue(this.url);
   }
  sendPaymentLink(){
    if(this.GeneratedLinkForm.valid){
      this.sendLinkLoader=true;
      let type;
      const value:any={
        link:this.GeneratedLinkForm.value.generatedLink,
      }
      if(this.isEmail){
      value.type=this.shareLink.email;
      value.email=this.GeneratedLinkForm.value.data;
       }
      else if(this.isSMS){
      value.type=this.shareLink.sms;
      value.mobile=this.GeneratedLinkForm.value.data;
      value.countryCode=this.GeneratedLinkForm.value.countryCode;
       }
        this.paymentService.sentpaymentLink(value).subscribe((res:any) =>{
        this.sendLinkLoader=false;
        this.notification.success(Messages.success, '', {
          nzKey: 'key'
        });
        this.chckBoxChange();
        this.isEmail=false;
        this.isSMS=false;
       },(err:any)=>{
        this.sendLinkLoader=false;
        this.notification.error(Messages.failed, '', {
          nzKey : 'key'
        });
        })
    }else{
      let error=''; 
      if(!(this.isEmail || this.isSMS)){
      error = 'Please select SMS/Email option';
      }
      else if(!this.GeneratedLinkForm.value.data){
      error = 'Please fill the valid SMS/Email';
      }
      this.notification.error(error, '', {
        nzKey: 'key'
        });
    }
    }
  generateLink(){
    this.router.navigate(['/payments/request-payment/']);
  }
  //To Copy to clipBoard
    copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.message.success('copied to clipboard');
      }
  //Binding qr code value.
   showQRCode(){
    this.qrValue = this.url;
   }
  //Show QRCode in Popup
   showQRCodeModalPopup(qrCodeModal: TemplateRef<{}>,qrCodeModalFooter:TemplateRef<{}>){
     this.payOutModal = this.modal.create({
      nzContent: qrCodeModal,
      nzFooter: qrCodeModalFooter,
      nzClosable: true,
      nzMaskClosable: false,
      //nzOnOk: () => this.createOrder(),
     });
    this.showQRCode();
  }
  //Download QRCode Image
  getPdfForQRCode(){
    this.paymentService.getPdfForQRCode('qrCode');
  }
  getCountries() {
    this.ordersService.getAllCountries().subscribe((response: any) => {
      this.countriesList = response.data.countries;
    });
  }
}
